import $ from 'jquery';
import { gsap } from "gsap";
import domReady from '@wordpress/dom-ready';

class Sidecart {
	constructor (params) {
		this.$cache       = {};
		this.$cache.main  = params.target;

		this.isOpen = false;
		
		this.initCache();
		this.initEventsConst();
		this.registerEvents();
	}
	
	initCache() {
		this.$cache.html = $('html');
		this.$cache.openCTA = $('.sidecart-opener');
		this.$cache.bg = this.$cache.main.find('.sidecart-bg');
		this.$cache.content = this.$cache.main.find('.sidecart-content');
		this.$cache.closeCTA = this.$cache.content.find('.sidecart-closer');
	}

	initEventsConst() {
		this.openEvent = (e) => this.open(e);
		this.closeEvent = () => this.close();
	}
	
	registerEvents() {
		this.$cache.openCTA.on('click', this.openEvent);
		this.$cache.closeCTA.on('click', this.closeEvent);
		this.$cache.bg.on('click', this.closeEvent);
	}
	
	close() {
		if(!this.isOpen) return false;
		
		const tl = gsap.timeline({paused: true, onComplete: () => {
			this.$cache.html.removeClass('scroll-disabled');
			this.$cache.main.removeClass('is-open');
			this.isOpen = false;
		}});

		tl.to(this.$cache.content, {x: "100%", duration: 0.5, force3D: true, ease: "power2.out"}, 0);
		tl.to(this.$cache.bg, {opacity: 0, duration: 0.7, ease: "power2.out"}, 0);

		tl.play();
	}

	open(e) {
		e.preventDefault();
		
		if(this.isOpen) return false;
		this.isOpen = true;
		
		const tl = gsap.timeline({paused: true});
		tl.add(() => {
			this.$cache.html.addClass('scroll-disabled');
			this.$cache.main.addClass('is-open');
		}, 0);
		tl.fromTo(this.$cache.bg, {opacity: 0}, {opacity: 1, duration: 0.8, ease: "power2.out"}, 0);
		tl.fromTo(this.$cache.content, {x: "100%"}, {x: "0%", duration: 0.6, force3D: true, ease: "power2.out"}, 0.15);

		tl.play();
	}
}

export default Sidecart;

domReady(() => {
	const $target = $('#sidecart');
	if ($target.length) {
		new Sidecart({ target: $target });
	}
});